import _objectSpread from "E:\\Workspaces\\VScode\\vue3+TS\\vue\u6848\u4F8B\\cloudMusicProject-master\\node_modules\\@babel\\runtime\\helpers\\esm\\objectSpread2.js";
import { defineComponent, reactive, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { useState } from "@/hooks/mapGet/index.js";
import { brightenKeyword } from "@/hooks/lightKeyword";
import SearchVue from "@/baseui/search/Search.vue";
import Loading from "@/baseui/loading/loading.vue";
export default defineComponent({
  name: "navHeader",
  setup: function setup() {
    var router = useRouter();
    var route = useRoute();
    var store = useStore();
    var refSearchVue = ref();
    var state = useState("Search", ["searchInfo", "searchHot"]);
    var iptValue = ref("");
    store.dispatch("Search/getHotSearch");
    var isRouter = ref(route.path);
    var isHeaderRight = ref(true);
    /* 头部导航菜单 */

    var headerRouter = reactive([{
      title: "个性推荐",
      router: "/main/home"
    }, {
      title: "歌单",
      router: "/main/playlist"
    }, {
      title: "排行榜",
      router: "/main/rankList"
    }, {
      title: "歌手",
      router: "/main/artistList"
    }, {
      title: "最新音乐",
      router: "/main/latestMusic"
    }, {
      title: "独家放送",
      router: "/main/alone"
    }]);
    /* 监听路由的变化 */

    watch(function () {
      return route.path;
    }, function (newValue) {
      //找不到返回-1 !== -1 表示 找到了
      if (~newValue.indexOf("/video")) {
        isHeaderRight.value = false;
      } else {
        isHeaderRight.value = true;
      }

      isRouter.value = newValue;
    }, {
      immediate: true
    });
    /* 导航跳转路由 */

    var headerClick = function headerClick(itemRouter) {
      isRouter.value = itemRouter;
      router.push(itemRouter);
    };
    /* 关键字高亮 */


    var lightKeyword = brightenKeyword;
    /* 热搜item点击事件 */

    var hotClick = function hotClick(keyword) {
      refSearchVue.value.inputValue = keyword;
      refSearchVue.value.handleChangeValue();
      router.push("/main/searchContent/".concat(keyword));
    };
    /* 相关结果点击事件 */


    var resultClick = function resultClick() {
      router.push("/main/searchContent/".concat(iptValue.value));
    };
    /* 输入框值变事件 */


    var handleChangeValue = function handleChangeValue(value) {
      iptValue.value = value;
      store.dispatch("Search/getSearchInfo", value);
    };
    /* 单曲点击事件 */


    var playerClick = function playerClick(id) {
      store.dispatch("player/setCurrentSong", id);
    };
    /* 歌手点击事件 */


    var songerClick = function songerClick(id) {
      router.push("/main/artistdetail/".concat(id));
    };
    /* 专辑点击事件 */


    var albumClick = function albumClick(id) {
      router.push("/main/albumdetail/".concat(id));
    };
    /* 歌单点击事件 */


    var sheetClick = function sheetClick(id) {
      router.push("/main/playlistdetail/".concat(id));
    };
    /* 导航回退按钮 */


    var backClick = function backClick() {
      router.go(-1);
    };
    /* 导航前进按钮 */


    var forwardClick = function forwardClick() {
      router.go(1);
    };
    /* 点击图片回到首页按钮 */


    var homeClick = function homeClick() {
      if (route.path.indexOf("/main/home") == -1) {
        router.push("/main/home");
      }
    };

    return _objectSpread(_objectSpread({}, state), {}, {
      refSearchVue: refSearchVue,
      isRouter: isRouter,
      isHeaderRight: isHeaderRight,
      headerRouter: headerRouter,
      iptValue: iptValue,
      headerClick: headerClick,
      handleChangeValue: handleChangeValue,
      lightKeyword: lightKeyword,
      hotClick: hotClick,
      resultClick: resultClick,
      playerClick: playerClick,
      songerClick: songerClick,
      albumClick: albumClick,
      sheetClick: sheetClick,
      backClick: backClick,
      forwardClick: forwardClick,
      homeClick: homeClick
    });
  },
  components: {
    SearchVue: SearchVue,
    Loading: Loading
  }
});